import { render, staticRenderFns } from "./VerifyEmailForm.vue?vue&type=template&id=2c12b7d7&"
import script from "./VerifyEmailForm.vue?vue&type=script&lang=js&"
export * from "./VerifyEmailForm.vue?vue&type=script&lang=js&"
import style0 from "./VerifyEmailForm.vue?vue&type=style&index=0&id=2c12b7d7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports